import React, { Component } from 'react';
import { DashboardCard } from './DashboardCard';
import { ClipboardCheckIcon, CheckCircleIcon, XCircleIcon, AlertTriangleIcon, ArrowUpDownIcon, FilterIcon, DropletIcon, ZapIcon, CircleIcon, ConstructionIcon, ChevronLeftIcon, ChevronRightIcon, SettingsIcon, InfoIcon } from 'lucide-react';
export function ClaimsOverview() {
  // Mock data
  const warrantyData = {
    total: 125,
    approved: 100,
    rejected: 25,
    warranty: 80,
    technicalIssue: 20,
    missingPart: 5
  };
  const regions = [{
    name: 'R1 Aisco MENA',
    value: 20,
    max: 50,
    percentage: 40
  }, {
    name: 'R2 Aisco Africa',
    value: 30,
    max: 50,
    percentage: 60
  }, {
    name: 'R3 Aisco EUROPE',
    value: 50,
    max: 50,
    percentage: 100
  }, {
    name: 'R4 Aisco AMERICA',
    value: 25,
    max: 50,
    percentage: 50
  }];
  const intelligentBoardIssues = [{
    id: 1,
    title: 'Leaks and Seal Damage',
    icon: <DropletIcon size={18} data-id="element-1099" data-mp="32eactafe0jna" />,
    color: 'blue',
    description: ['Issues with O-rings, gaskets, seals in critical components.', 'Problems with leaking, causing noise and wear.'],
    affectedParts: ['12-90301', '12-80201', '12-93311'],
    chartData: {
      jan: 10,
      feb: 15,
      mar: 12,
      apr: 25,
      may: 35,
      jun: 40,
      jul: 30
    }
  }, {
    id: 2,
    title: 'Defective Electrical Components',
    icon: <ZapIcon size={18} data-id="element-1100" data-mp="1i3yj97h3snfd" />,
    color: 'amber',
    description: ['Issues with relays, contactors, pressure sensors, and SCADA system control problems.', 'Failures in remote control systems and connectivity within the irrigation system.'],
    affectedParts: ['12-92311', '12-85001', '12-80021'],
    chartData: {
      jan: 5,
      feb: 8,
      mar: 10,
      apr: 12,
      may: 15,
      jun: 18,
      jul: 20
    }
  }, {
    id: 3,
    title: 'Wheel and Tire Issues',
    icon: <CircleIcon size={18} data-id="element-1101" data-mp="3sy45p82gbso2" />,
    color: 'red',
    description: ['Damaged tires are frequently installed from the production line (not from transit).', 'Cracks and punctures wear on tire structure.'],
    affectedParts: ['12-85001', '12-80011', '12-93111'],
    chartData: {
      jan: 8,
      feb: 12,
      mar: 10,
      apr: 18,
      may: 25,
      jun: 30,
      jul: 20
    }
  }];
  return <div className="space-y-6" data-id="element-1102" data-mp="21u2jpdz8hkmj">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1103" data-mp="25tbfsphqxul9">
        <DashboardCard icon={<ClipboardCheckIcon size={20} className="text-blue-400" data-id="element-1105" data-mp="2asnzj1dbmljm" />} title="Warranty Summary" data-id="element-1104" data-mp="25rgq6xvj5eau">
          <div className="flex flex-col items-center" data-id="element-1106" data-mp="2aqtlm70gvtp1">
            <div className="text-6xl font-bold text-white mb-6" data-id="element-1107" data-mp="2fqg0slzuvk0h">
              {warrantyData.total}
            </div>
            <div className="grid grid-cols-2 gap-6 w-full" data-id="element-1108" data-mp="2kj9558rewqc1">
              <div className="text-center" data-id="element-1109" data-mp="2phtweioorzoc">
                <div className="text-green-400 font-medium mb-1" data-id="element-1110" data-mp="2pjn3fz37olwv">Approved</div>
                <div className="text-2xl font-bold text-white" data-id="element-1111" data-mp="2tkqiwkhckfxk">
                  {warrantyData.approved}
                </div>
                <div className="mt-2 text-xs text-blue-300" data-id="element-1112" data-mp="2yfw41h2xdqkl">
                  {Math.round(warrantyData.approved / warrantyData.total * 100)}
                  % of total
                </div>
              </div>
              <div className="text-center" data-id="element-1113" data-mp="du77wojum6yv">
                <div className="text-red-400 font-medium mb-1" data-id="element-1114" data-mp="dv04iwp3fg3a">Rejected</div>
                <div className="text-2xl font-bold text-white" data-id="element-1115" data-mp="8vnlyo598v6i">
                  {warrantyData.rejected}
                </div>
                <div className="mt-2 text-xs text-blue-300" data-id="element-1116" data-mp="15k3bwlca16k5">
                  {Math.round(warrantyData.rejected / warrantyData.total * 100)}
                  % of total
                </div>
              </div>
            </div>
            <div className="w-full mt-6" data-id="element-1117" data-mp="wqykkf4vxnty">
              <div className="w-full bg-slate-700/50 rounded-full h-2.5 overflow-hidden" data-id="element-1118" data-mp="rurpjhe11wqs">
                <div className="bg-green-500 h-2.5 rounded-full" style={{
                width: `${warrantyData.approved / warrantyData.total * 100}%`
              }} data-id="element-1119" data-mp="1p9vu3dpa31ym"></div>
              </div>
            </div>
          </div>
        </DashboardCard>
        <DashboardCard icon={<AlertTriangleIcon size={20} className="text-blue-400" data-id="element-1121" data-mp="145hby01dttl7" />} title="Warranty Types" className="md:col-span-2" data-id="element-1120" data-mp="141th8xk7b14w">
          <div className="grid grid-cols-3 gap-4 mb-6" data-id="element-1122" data-mp="v2pxdrd7mhpc">
            <WarrantyTypeCard label="Warranty" value={warrantyData.warranty} percentage={warrantyData.warranty / warrantyData.total * 100} color="blue" data-id="element-1123" data-mp="v4at3kb9g6os" />
            <WarrantyTypeCard label="Technical Issue" value={warrantyData.technicalIssue} percentage={warrantyData.technicalIssue / warrantyData.total * 100} color="amber" data-id="element-1124" data-mp="1nqluuyalsdn6" />
            <WarrantyTypeCard label="Missing Part" value={warrantyData.missingPart} percentage={warrantyData.missingPart / warrantyData.total * 100} color="emerald" data-id="element-1125" data-mp="1e1c0tcw78kwf" />
          </div>
          <div className="space-y-4" data-id="element-1126" data-mp="1iyarflgnm9pv">
            {regions.map(region => <div key={region.name} className="space-y-2" data-id="element-1127" data-mp="26oyddanemzvf">
                <div className="flex justify-between" data-id="element-1128" data-mp="2bgpyh5nskde6">
                  <span className="text-sm text-blue-300" data-id="element-1129" data-mp="2bi9c0oi2cac9">{region.name}</span>
                  <span className="text-sm font-medium text-white" data-id="element-1130" data-mp="2kugk9xkndmq4">
                    {region.value} claims
                  </span>
                </div>
                <div className="w-full bg-slate-700/50 rounded-full h-2 overflow-hidden" data-id="element-1131" data-mp="2ulbhty3cg8qv">
                  <div className="bg-blue-500 h-2 rounded-full" style={{
                width: `${region.percentage}%`
              }} data-id="element-1132" data-mp="2un5r2f596cf4"></div>
                </div>
              </div>)}
          </div>
        </DashboardCard>
      </div>
      <div className="mb-4" data-id="element-1133" data-mp="1xvkagy9yer3n">
        <div className="flex items-center justify-between mb-4" data-id="element-1134" data-mp="1xwdjy70aruph">
          <div className="flex items-center" data-id="element-1135" data-mp="2bvd0erdnp3ak">
            <div className="flex items-center space-x-1 bg-slate-800 px-3 py-1 rounded-lg" data-id="element-1136" data-mp="2bw4vm13ccz0b">
              <span className="text-blue-300 font-bold" data-id="element-1137" data-mp="26u5tsvn92a5h">I</span>
              <span className="text-blue-300 font-bold" data-id="element-1138" data-mp="3n97dczh6fum2">B</span>
              <span className="text-blue-300 font-bold" data-id="element-1139" data-mp="3nbtkiy05o83r">I</span>
              <span className="text-xs text-blue-400" data-id="element-1140" data-mp="3iadwqy6lfnho">v1.0</span>
            </div>
            <h2 className="text-xl font-bold text-white ml-3" data-id="element-1141" data-mp="3qajyzr19hqzj">
              Intelligent <span className="text-blue-400" data-id="element-1142" data-mp="3ucnm5cxamk0n">B</span>oard{' '}
              <span className="text-blue-400" data-id="element-1143" data-mp="3uf9sxacd0vht">I</span>ssue
            </h2>
          </div>
          <div className="flex items-center space-x-2" data-id="element-1144" data-mp="37ouysc8gslf">
            <button className="text-blue-300 hover:text-white transition-colors" data-id="element-1145" data-mp="868md89liwl6">
              <SettingsIcon size={18} data-id="element-1146" data-mp="36nvxuwmtqlt5" />
            </button>
            <button className="text-blue-300 hover:text-white transition-colors" data-id="element-1147" data-mp="36pfeioce6yvg">
              <InfoIcon size={18} data-id="element-1148" data-mp="3bn8lhjlirwws" />
            </button>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1149" data-mp="3gkqv7c7d2g5u">
          {intelligentBoardIssues.map(issue => <IssueCard key={issue.id} issue={issue} data-id="element-1150" data-mp="3ldabwi1chrev" />)}
        </div>
      </div>
    </div>;
}
function WarrantyTypeCard({
  label,
  value,
  percentage,
  color
}) {
  const colors = {
    blue: 'bg-blue-500/20 text-blue-300',
    amber: 'bg-amber-500/20 text-amber-300',
    emerald: 'bg-emerald-500/20 text-emerald-300'
  };
  return <div className={`rounded-lg p-4 ${colors[color]}`} data-id="element-1151" data-mp="2lam0n4owmkii">
      <div className="text-lg font-medium mb-2" data-id="element-1152" data-mp="2gdbzirs5kkeu">{label}</div>
      <div className="text-3xl font-bold text-white mb-2" data-id="element-1153" data-mp="2beinl3sil1gs">{value}</div>
      <div className="w-full bg-slate-700/50 rounded-full h-1.5 overflow-hidden" data-id="element-1154" data-mp="2bco2nph8t9cp">
        <div className={`bg-${color}-500 h-1.5 rounded-full`} style={{
        width: `${percentage}%`
      }} data-id="element-1155" data-mp="26emjl4jtha18"></div>
      </div>
      <div className="mt-1 text-xs" data-id="element-1156" data-mp="22fx9plxzmamc">{Math.round(percentage)}% of total</div>
    </div>;
}
function IssueCard({
  issue
}) {
  const colors = {
    blue: 'bg-blue-500/20 text-blue-300 border-blue-500/30',
    amber: 'bg-amber-500/20 text-amber-300 border-amber-500/30',
    red: 'bg-red-500/20 text-red-300 border-red-500/30'
  };
  return <div className={`border rounded-xl p-5 ${colors[issue.color]}`} data-id="element-1157" data-mp="1iqd22etmz8fw">
      <div className="flex justify-between items-start mb-4" data-id="element-1158" data-mp="1iro6mguwok82">
        <div className="flex items-center" data-id="element-1159" data-mp="1epjdrkca7rmh">
          <div className="p-2 rounded-lg bg-slate-800/50 mr-2" data-id="element-1160" data-mp="32ky11yzww1ms">
            {issue.icon}
          </div>
          <h3 className="text-lg font-bold text-white" data-id="element-1161" data-mp="37k0z2zhh57l9">{issue.title}</h3>
        </div>
        <div className="flex space-x-1" data-id="element-1162" data-mp="37hofkhw2ip63">
          <button className="p-1 rounded-lg bg-slate-800/50 hover:bg-slate-700/50 transition-colors" data-id="element-1163" data-mp="2snjoiah3zwzr">
            <ChevronLeftIcon size={16} data-id="element-1164" data-mp="2xktk67v3d4w1" />
          </button>
          <button className="p-1 rounded-lg bg-slate-800/50 hover:bg-slate-700/50 transition-colors" data-id="element-1165" data-mp="2jugb226grk54">
            <ChevronRightIcon size={16} data-id="element-1166" data-mp="2ol6h7hmprr0v" />
          </button>
        </div>
      </div>
      <div className="h-24 mb-3 relative" data-id="element-1167" data-mp="2omzpf1cz6jaz">
        <div className="absolute inset-0 flex items-end justify-between px-2" data-id="element-1168" data-mp="29x1xqbfu7bh1">
          {Object.entries(issue.chartData).map(([month, value]) => <div key={month} className="flex flex-col items-center" data-id="element-1169" data-mp="2evmv833pfh1s">
              <div className={`w-6 bg-${issue.color === 'blue' ? 'blue' : issue.color === 'amber' ? 'amber' : 'red'}-500 rounded-t-sm`} style={{
            height: `${value * 1.5}px`
          }} data-id="element-1170" data-mp="20wna35fehkad"></div>
              <div className="text-xs mt-1" data-id="element-1171" data-mp="1m9wzfdfsefc4">
                {month.substring(0, 3).toUpperCase()}
              </div>
            </div>)}
        </div>
        <div className="absolute top-0 left-0 right-0 flex justify-center" data-id="element-1172" data-mp="1hc52g50ac312">
          <div className="px-2 py-0.5 bg-red-500/20 text-red-300 text-xs rounded-full" data-id="element-1173" data-mp="1vav47xy1uqvr">
            Peak
          </div>
        </div>
      </div>
      <div className="space-y-2 mb-4" data-id="element-1174" data-mp="2577u0kqh4kl8">
        {issue.description.map((desc, idx) => <p key={idx} className="text-sm" data-id="element-1175" data-mp="208o8glfslate" data-mpi={idx}>
            {desc}
          </p>)}
      </div>
      <div data-id="element-1176" data-mp="206tx9yubox2i">
        <div className="text-xs mb-1" data-id="element-1177" data-mp="2e01npn6o3mim">Affected parts:</div>
        <div className="flex flex-wrap gap-2" data-id="element-1178" data-mp="2dzjlm9xbqe2s">
          {issue.affectedParts.map((part, idx) => <div key={idx} className="px-2 py-1 bg-slate-800/50 rounded-md text-xs" data-id="element-1179" data-mp="29zr6tfhc7boz" data-mpi={idx}>
              {part}
            </div>)}
        </div>
      </div>
    </div>;
}